import { faTooth } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

// Component with 4 teeth + 1 tooth that is fallen over to indicate error
export const CredentialsFailedError = () => {
  return (
    <div className="vai-flex vai-flex-col vai-items-center vai-justify-center vai-h-96 vai-text-center vai-bg-gray-50 vai-rounded-lg vai-p-8">
      {/* Tooth icons row */}
      <div className="vai-flex vai-gap-4 vai-mb-6">
        <FontAwesomeIcon
          icon={faTooth}
          className="vai-text-gray-300 vai-text-5xl"
        />
        <FontAwesomeIcon
          icon={faTooth}
          className="vai-text-gray-300 vai-text-5xl"
        />
        <FontAwesomeIcon
          icon={faTooth}
          className="vai-text-gray-300 vai-text-5xl"
        />
        <FontAwesomeIcon
          icon={faTooth}
          className="vai-text-gray-300 vai-text-5xl"
        />
        <FontAwesomeIcon
          icon={faTooth}
          className="vai-text-gray-300 vai-text-5xl vai-transform vai-rotate-90"
        />
      </div>

      {/* Error message */}
      <p className="vai-text-gray-600 vai-text-base vai-font-medium">
        <Trans>Credentials failed to load</Trans>
      </p>
    </div>
  );
};
